import React from 'react';
import styled from 'styled-components';
import { ErrorMessage, FormikProps } from 'formik';

import { FORM_TEXTS } from '../../formDictionary';
import { LabeledField } from '../../../../LabeledField';
import Field from '../../../../fields/Field';
import { LegalField } from '../LegalField';
import { ReviewFormValues } from '../../types';
import { ErrorMessageContainer } from '../../../../fields/common/ErrorMessageContainer';

const Title = styled.p`
  margin-bottom: 16px;
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.2px;
  font-weight: 600;
`;

type DataTransferStepProps = FormikProps<ReviewFormValues>;

const DataTransferStep = ({
  errors, touched, values, handleBlur, handleChange,
}: DataTransferStepProps) => {
  const { zipcode, phone } = FORM_TEXTS;

  return (
    <>
      <Title>Super ! On a besoin de deux dernières informations pour cela :</Title>
      <LabeledField label={zipcode.label} error={errors.zipcode && touched.zipcode} isFullWidthLabel>
        <Field
          placeholder={zipcode.placeholder}
          type="text"
          name="zipcode"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.zipcode}
          valid={touched.zipcode && !errors.zipcode}
        />
        <ErrorMessage component={ErrorMessageContainer} name="zipcode" />

      </LabeledField>
      <LabeledField label={phone.label} error={errors.phone && touched.phone} isFullWidthLabel>
        <Field
          placeholder={phone.placeholder}
          type="text"
          name="phone"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.phone}
          valid={touched.phone && !errors.phone}
        />
        <ErrorMessage component={ErrorMessageContainer} name="phone" />
      </LabeledField>
      <LegalField errors={errors} values={values} touched={touched} handleChange={handleChange} />
    </>
  );
};

export { DataTransferStep };
